import { useState } from 'react';
import { useAuthStore } from '@/store/authStore';
import { RegisterFormData } from '../types';
import { validatePhoneNumber } from '@/utils/validation';
import { validateRegistrationPhone } from '@/utils/validation/registerValidation';

export function useRegisterForm() {
  const { addRegisterRequest } = useAuthStore();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (data: RegisterFormData) => {
    if (isSubmitting) return;

    // Validate phone number format
    const phoneValidation = validatePhoneNumber(data.phoneNumber);
    if (phoneValidation !== true) {
      setError(phoneValidation);
      return false;
    }

    // Validate registration eligibility
    const registrationValidation = validateRegistrationPhone(data.phoneNumber);
    if (!registrationValidation.isValid) {
      setError(registrationValidation.message);
      return false;
    }

    setIsSubmitting(true);
    try {
      const request = {
        id: crypto.randomUUID().replace(/[-]/g, ""),
        status: 'pending' as const,
        timestamp: Date.now(),
        data
      };
      
      addRegisterRequest(request);
      setIsSuccess(true);
      setError(null);
      return true;
    } catch (error) {
      console.error('Error submitting registration:', error);
      setError('حدث خطأ أثناء تقديم الطلب');
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    onSubmit,
    isSubmitting,
    isSuccess,
    error
  };
}